import { render, staticRenderFns } from "./PersonnelSelection.vue?vue&type=template&id=c05452f2&scoped=true"
import script from "./PersonnelSelection.vue?vue&type=script&lang=js"
export * from "./PersonnelSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05452f2",
  null
  
)

export default component.exports